import { render, staticRenderFns } from "./EditFaqQuestion.vue?vue&type=template&id=6c63de34&scoped=true&"
import script from "./EditFaqQuestion.vue?vue&type=script&lang=js&"
export * from "./EditFaqQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c63de34",
  null
  
)

export default component.exports